import { collection, addDoc, Timestamp } from 'firebase/firestore'
import { db } from '../config/firebase'

export interface ExecutionRecord {
  studentId: string
  code: string
  executionType: 'normal' | 'step'
  timestamp: Timestamp
  sampleId?: string
  url: string
}

/**
 * 実行記録サービス
 */
export class ExecutionLogger {
  private static instance: ExecutionLogger
  private studentId: string | null = null

  private constructor() {
    // シングルトンパターン
  }

  /**
   * インスタンスを取得
   */
  public static getInstance(): ExecutionLogger {
    if (!ExecutionLogger.instance) {
      ExecutionLogger.instance = new ExecutionLogger()
    }
    return ExecutionLogger.instance
  }

  /**
   * 学生番号を設定
   */
  public setStudentId(studentId: string): void {
    this.studentId = studentId
  }

  /**
   * 実行を記録
   */
  public async logExecution(
    code: string,
    executionType: 'normal' | 'step',
    sampleId?: string
  ): Promise<void> {
    if (!this.studentId) {
      console.error('Student ID is not set')
      return
    }

    if (!db) {
      console.error('Firebase is not initialized')
      return
    }

    try {
      const record: ExecutionRecord = {
        studentId: this.studentId,
        code,
        executionType,
        timestamp: Timestamp.now(),
        url: window.location.href,
      }

      if (sampleId) {
        record.sampleId = sampleId
      }

      // Firestoreに記録
      const docRef = await addDoc(
        collection(db, 'students', this.studentId, 'executions'),
        record
      )

      console.log('Execution logged with ID:', docRef.id)
    } catch (error) {
      console.error('Error logging execution:', error)
      // エラーが発生してもユーザーの実行を妨げない
    }
  }

  /**
   * 現在の学生番号を取得
   */
  public getStudentId(): string | null {
    return this.studentId
  }
}